import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OpenAssessModel } from 'src/app/core/models/self-assessment/openAssess-model';
import { SelfAssessmentT2DetailsComponent } from '../../self-assessment-template2/self-assessment-t2-details/self-assessment-t2-details.component';

@Component({
  selector: 'app-self-assessment-modal-dialog',
  templateUrl: './self-assessment-modal-dialog.component.html',
  styleUrls: ['./self-assessment-modal-dialog.component.scss']
})
export class SelfAssessmentModalDialogComponent {
  assessmentType = 'self';
  id: number = 0;
  templateNo = 1;
  @ViewChild(SelfAssessmentT2DetailsComponent) selfAssessmentT2Component: SelfAssessmentT2DetailsComponent | undefined;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OpenAssessModel,
    public dialogRef: MatDialogRef<SelfAssessmentModalDialogComponent>
  ) {
    this.id = this.data.id;
    this.templateNo = this.data.templateNo;
  }
  closeDialog() {
   // Add your custom logic or function call here
    if(this.templateNo === 2){
      this.selfAssessmentT2Component?.onLeavingPage();
    }
    // Close the dialog
    this.dialogRef.close();
  }
}
